import React from 'react';
import { Award, TrendingUp } from 'lucide-react';
interface OverallStat {
  value: string;
  label: string;
  sublabel: string;
}
interface QuickWin {
  company: string;
  result: string;
  industry: string;
}
interface SuccessStoriesSlideProps {
  content: {
    overallStats: OverallStat[];
    quickWins: QuickWin[];
  };
}
export function SuccessStoriesSlide({
  content
}: SuccessStoriesSlideProps) {
  return <div className="bg-[#F5F5F5] rounded-2xl p-12" data-id="element-200">
      <h2 className="text-4xl font-bold text-[#1C1C1C] mb-4" data-id="element-201">
        Client Success Metrics
      </h2>
      <p className="text-xl text-[#4D4D4D] mb-12" data-id="element-202">
        Proven results across 23 industries
      </p>

      <div className="grid grid-cols-4 gap-6 mb-12" data-id="element-203">
        {content.overallStats.map((stat, index) => <div key={index} className="bg-white rounded-xl p-6 text-center border-t-4 border-[#0FB07D]" data-id="element-204">
            <div className="text-5xl font-bold text-[#0FB07D] mb-3" data-id="element-205">
              {stat.value}
            </div>
            <div className="text-lg font-semibold text-[#1C1C1C] mb-1" data-id="element-206">
              {stat.label}
            </div>
            <div className="text-sm text-[#4D4D4D]" data-id="element-207">{stat.sublabel}</div>
          </div>)}
      </div>

      <div className="bg-gradient-to-br from-[#017C6D] to-[#0FB07D] rounded-xl p-8" data-id="element-208">
        <div className="flex items-center gap-3 mb-6" data-id="element-209">
          <TrendingUp className="text-white" size={28} data-id="element-210" />
          <h3 className="text-2xl font-bold text-white" data-id="element-211">Quick Wins</h3>
        </div>
        <div className="grid grid-cols-2 gap-4" data-id="element-212">
          {content.quickWins.map((win, index) => <div key={index} className="bg-white/10 backdrop-blur rounded-lg p-6 border border-white/20" data-id="element-213">
              <div className="flex items-start gap-3 mb-3" data-id="element-214">
                <Award className="text-white flex-shrink-0" size={24} data-id="element-215" />
                <div data-id="element-216">
                  <div className="font-bold text-white text-lg mb-1" data-id="element-217">
                    {win.company}
                  </div>
                  <div className="text-sm text-white/70" data-id="element-218">{win.industry}</div>
                </div>
              </div>
              <div className="text-xl font-semibold text-white" data-id="element-219">
                {win.result}
              </div>
            </div>)}
        </div>
      </div>
    </div>;
}
export default SuccessStoriesSlide;